import { apiClient } from '@/shared/lib/axios';
import { BankBranchType } from '@/types/admin-clinic-info';
import { useQuery } from '@tanstack/react-query';

type Response<T> = {
  data: T[];
};

export const getBankBranchType = async (
  siteType: string | null
): Promise<Response<BankBranchType>> => {
  const response = await apiClient.get<Response<BankBranchType>>(
    `/admin/${siteType}/master-data/bank-branch-types`
  );
  return response.data;
};

export const useAdminBankBranchType = (siteType: string | null) => {
  return useQuery({
    queryKey: ['bank-branch-type', siteType],
    queryFn: () => getBankBranchType(siteType),
  });
};
